/* Shared form state: variant selection, quick view and direct card adds. */
(function () {
  function sync(form) {
    var box = form.querySelector('[data-kk-backorder-fields]');
    var id = form.querySelector('[name="id"]');
    if (!box || !id) return null;
    var states;
    try { states = JSON.parse(box.dataset.states); } catch (_) { return null; }
    var state = states[id.value];
    var backorder = state === 'backorder';
    box.querySelectorAll('input').forEach(function (input) { input.disabled = !backorder; });
    var note = (form.closest('product-info') || box).querySelector('[data-kk-backorder-note]');
    if (note) note.hidden = !backorder;
    var host = form.closest('product-form');
    var notify = host && host.querySelector('[data-kk-standard-notify]');
    if (notify) {
      notify.hidden = state === 'in_stock';
      var trigger = notify.querySelector('[data-kk-notify-trigger]');
      if (trigger) trigger.dataset.kkNotifyTrigger = trigger.dataset.kkNotifyTrigger.split(':')[0] + ':' + id.value;
      var opener = notify.querySelector('modal-opener');
      var modal = opener && document.querySelector(opener.dataset.modal);
      var signup = modal && modal.querySelector('[data-kk-notify]');
      if (signup) signup.dataset.kkRestockVariant = id.value;
      if (window.KKNotify) window.KKNotify.sync();
    }
    var button = form.querySelector('[name="add"]');
    if (button) {
      if (!button.dataset.normalLabel) button.dataset.normalLabel = button.dataset.availableLabel || window.variantStrings.addToCart;
      button.dataset.availableLabel = backorder ? box.dataset.label : button.dataset.normalLabel;
    }
    form.querySelectorAll('.shopify-payment-button, [data-kk-express-wrapper]').forEach(function (el) { el.hidden = backorder || state === 'unavailable' || box.dataset.blocked === 'true'; });
    return box.dataset.blocked === 'true' || (state === 'unavailable' && box.dataset.preorder !== 'true') ? false : state;
  }
  window.KKBackorder = { sync: sync };
  document.addEventListener('change', function (event) {
    var form = event.target.closest('form');
    if (form) sync(form);
  });
  // Runs before global.js's document capture handler serializes the form.
  window.addEventListener('submit', function (event) {
    if (sync(event.target) === false) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
})();
